var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { HDSButton } from "@here/hds-react-components/Button";
import { useDispatch } from "react-redux";
import { setDiscardAllAnnotations } from "../../../store/reducers/jsMapSlice";
import { ANNOTATION_MODAL_BUTTON } from "../../../pages/JsMapCreator/constants";
import { annotateButton } from "../helper";
export var ConfirmFooter = function (props) {
    var setShowModal = props.setShowModal;
    var dispatch = useDispatch();
    var discard = function () {
        setShowModal(false);
        dispatch(setDiscardAllAnnotations(true));
    };
    return (_jsxs("div", __assign({ style: { display: "flex", gap: "10px", justifyContent: "flex-end" }, onClick: discard }, { children: [_jsx(HDSButton, __assign({ variant: "secondary", size: "small" }, { children: _jsx("div", { children: ANNOTATION_MODAL_BUTTON.DISCARD }) })), _jsx(HDSButton, __assign({ variant: "primary", size: "small", onClick: function () {
                    setShowModal(false);
                    annotateButton.setState(H.ui.base.Button.State.DOWN);
                } }, { children: ANNOTATION_MODAL_BUTTON.KEEP }))] })));
};
